import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import axios from '../config/http.js'
import '../static/iconfont/iconfont.css'
import '../static/devices/iconfont.css'
import ElementUI from 'element-ui';
import VueCookies from 'vue-cookies'
import NProgress from 'nprogress'
import hasPermission from '@/components/libs/hasPermission' //按钮权限
import 'nprogress/nprogress.css'
import 'element-ui/lib/theme-chalk/index.css';
import './assets/base.css'
import './icons' // icon
import './assets/ali/iconfont.css'

import {showFullScreenLoading,hideFullScreenLoading} from '@/common/loading.js'
import uploader from "@/common/uploader.js"
import Antd from 'ant-design-vue';
import "ant-design-vue/dist/antd.css";

Vue.use(Antd);
Vue.use(VueCookies)
Vue.use(ElementUI);
Vue.config.productionTip = false
Vue.prototype.$http = axios
Vue.prototype.showFullScreenLoading = showFullScreenLoading
Vue.prototype.hideFullScreenLoading = hideFullScreenLoading
Vue.prototype.$uploader = uploader;
Vue.use(hasPermission);


new Vue({
  el: '#app',
  router,
  store,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js